import React, { useState, useEffect, useMemo } from 'react'
import { StatusBar, View, Dimensions, SafeAreaView } from 'react-native'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import NavigationTopbar from '../../../../components/NavigationTopbar'
import styles from './styles'
import MapComponent from '../../../../components/Map'
import Spinner from '../../../../components/Spinner'
import LoadsCarousel from '../LoadsCarousel'
import LoadDetails from '../../../../components/LoadDetails'
import { useTheme } from '../../../../theming/ThemeProvider'
import { loadDetailSelector } from '../../../../redux/loadDetails/loadDetailsSelector'

const { width, height } = Dimensions.get('window')
const LoadDetailsTemplate = ({ details, loading, isGroup, module, onGoBack }) => {
  const { tractorDetails } = useSelector(loadDetailSelector)
  const { theme } = useTheme()

  const [currentLoad, setCurrentLoad] = useState({
    index: details.loadIndex,
    load: details.load
  })

  useEffect(() => {
    setCurrentLoad({
      index: details.loadIndex,
      load: details.load
    })
  }, [details])

  const showCarousel = useMemo(() => {
    return module !== 'ready-to-invoice'
  }, [module])

  const showMap = useMemo(() => {
    return showCarousel && !loading && currentLoad.load && currentLoad.load.movementNumber
  }, [loading, currentLoad, showCarousel])

  const Container = useMemo(() => showCarousel ? View : SafeAreaView, [showCarousel])

  return !isGroup ? (
    <Container style={{ flex: 1, backgroundColor: theme.WHITE }}>
      <StatusBar />
      {showMap && (
        <View
          style={[
            styles.mapContainer,
            { width, height }
          ]}
        >
          <MapComponent
            routes={[[
              currentLoad.load.origin.coordinates,
              ...currentLoad.load.stops.map(stop => stop.coordinates),
              currentLoad.load.destination.coordinates
            ]]}
            tractorPosition={
              tractorDetails && tractorDetails.last_location &&
                tractorDetails.last_location.latitude && tractorDetails.last_location.longitude
                ? tractorDetails.last_location : null
            }
            width={width}
            height={height}
            mapId='drawerMap'
          />
        </View>
      )}
      {loading ? (
        <Spinner containerStyle={styles.loadingContainer} />
      ) : (
        <View
          style={[
            styles.container,
            styles.itemElevation,
            {
              paddingTop: showCarousel ? 40 : 10
            }
          ]}
        >
          <NavigationTopbar
            onGoBack={onGoBack}
            containerStyle={styles.navigationTopbar}
            showMap={showMap}
          />
          {showCarousel ? (
            <LoadsCarousel
              details={details}
              module={module}
              currentLoad={currentLoad}
              setCurrentLoad={setCurrentLoad}
            />
          ) : (
            <LoadDetails
              load={currentLoad.load}
              module={module}
              containerStyle={{ flex: 1 }}
            />
          )}
        </View>
      )}
    </Container>
  ) : <></>
}

LoadDetailsTemplate.propTypes = {
  details: PropTypes.object,
  loading: PropTypes.bool,
  isGroup: PropTypes.bool,
  module: PropTypes.string,
  onGoBack: PropTypes.func
}

export default LoadDetailsTemplate
